// extracted by mini-css-extract-plugin
export var form = "_dm-0";